import React from "react";

const CookiesPolicy = () => (
  <div className="container mt-4">
    <h2>Política de cookies</h2>
    <p>
      Este sitio utiliza exclusivamente cookies técnicas necesarias para
      mantener la sesión de usuario activa. Estas cookies permiten la
      autenticación y el acceso seguro a las funciones del sistema.
    </p>
    <p>
      No utilizamos cookies de análisis, publicidad ni de terceros. Las cookies
      empleadas son estrictamente necesarias y quedan exentas del deber de
      consentimiento según el artículo 22.2 de la Ley 34/2002 (LSSI-CE).
    </p>
    <p>
      <strong>Nombre:</strong> session<br />
      <strong>Finalidad:</strong> mantener la sesión iniciada.<br />
      <strong>Tipo:</strong> técnica / necesaria.<br />
      <strong>Duración:</strong> hasta el cierre del navegador o fin de la
      sesión.<br />
      <strong>Propietario:</strong> este dominio.
    </p>
  </div>
);

export default CookiesPolicy;